import { Book as BookType, Model } from '@topwrite/common';

class Book extends Model<BookType> {

}

export const book = new Book();
